/**
 * Load project-wide dependencies
 */
import "./bootstrap";
import { createApp } from "vue";
import $ from "jquery";
import Popper from "popper.js";
import "bootstrap";
import intlTelInput from "intl-tel-input/intlTelInputWithUtils";
import axios from "axios";
import TomSelect from "tom-select";
import "tom-select/dist/css/tom-select.bootstrap4.css";

const app = createApp({});
app.config.compilerOptions.comments = true;
// Only affects the runtime-compiled in-DOM root template (Blade output), not
// Vite-precompiled SFCs. No Blade view uses @{{ }} interpolation, so user data
// containing {{ ... }} must never be evaluated as a Vue expression (CSTI).
app.config.compilerOptions.delimiters = ["[[__vue__[[", "]]__vue__]]"];
window.$ = window.jQuery = $;
window.Popper = Popper;
window.IntlTelInput = intlTelInput;
window.axios = axios;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.TomSelect = TomSelect;

const activeCompanyIdMeta = document.head.querySelector(
    'meta[name="active-company-id"]'
);
if (activeCompanyIdMeta) {
    window.axios.defaults.headers.common["X-Salesbyte-Active-Company-Id"] =
        activeCompanyIdMeta.content;
}

import * as actionLog from "./src/actionLog.js";
window.ActionLog = actionLog;

import * as quoteViewTime from "./src/quoteViewTime.js";
window.QuoteViewTime = quoteViewTime;

import { chatTheme } from "./src/chatTheme.js";
window.SalesByteChatTheme = chatTheme;

import "./livewire-interceptors.js";
import "./livewire-morph-whitespace.js";
import "./livewire-morph-cloak.js";
import "./alpine/action-button.js";
import "./alpine/integration-clipboard.js";
import "./alpine/integration-focus.js";
import "./alpine/searchable-select.js";
import "./alpine/quote-sidebar.js";
import "./alpine/package-builder.js";

import { initSentry } from "./src/sentry.js";
initSentry(app);

/**
 * SalesByte components
 */
import SalesByteComponents from "./components/sb";
app.use(SalesByteComponents);

/**
 * Vue Signature Pad (Note: This library may require Vue 2.7+ or Vue 3 for certain versions)
 */
import VueSignaturePad from "vue-signature-pad";
app.use(VueSignaturePad);

/**
 * SweetAlert2
 */
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
app.use(VueSweetalert2);

/**
 * Vue I18n
 */
import { createSalesByteI18n } from "./i18n";

const i18n = createSalesByteI18n();
app.use(i18n);

/**
 * Ziggy Vue
 */
import { ZiggyVue } from "ziggy";
app.use(ZiggyVue);

/**
 * QR codes
 */
import QrcodeVue from "qrcode.vue";
app.component("vue-qr", QrcodeVue);

/**
 * vue-select
 */
import vSelect from "vue-select";
app.component("v-select", vSelect);

/**
 * Flicking
 */
import Flicking from "@egjs/vue3-flicking";
app.component("Flicking", Flicking);

// Import components
import AxiosForm from "./components/axiosForm.vue";
import PdfMultiView from "./components/pdfMultiView.vue";
import PdfView from "./components/pdfView.vue";
import PdfAll from "./components/pdfAll.vue";
import PrimarySignaturePrompt from "./components/primarySignaturePrompt.vue";
import QuoteCheckoutIframe from "./components/quoteCheckoutIframe.vue";
import QuoteCheckoutIframeModal from "./components/quoteCheckoutIframeModal.vue";
import BankIdSign from "./components/bankIdSign.vue";
import OnScreenSign from "./components/onScreenSign.vue";
import ExternalSign from "./components/externalSign.vue";
import SimpleSign from "./components/simpleSign.vue";
import BankIdV2Sign from "./components/bankIdV2/sign.vue";
import BankIdV2Prompt from "./components/bankIdV2/prompt.vue";
import QuoteProductPayment from "./components/quoteProductPayment.vue";
import QuotesIndex from "./components/quotes/index.vue";
import QuotesContactInput from "./components/quotes/contact-input.vue";
import QuotesDuplicateValidatedInput from "./components/quotes/duplicate-validated-input.vue";
import QuoteSignaturePoller from "./components/quotes/signature-poller.vue";
import QuoteEditTags from "./components/quotes/edit-tags.vue";
import QuoteMessagesCreate from "./components/quote_messages/create.vue";
import QuotesProjectApproval from "./components/quotes/project_approval.vue";
import ExpandableCard from "./components/expandableCard.vue";
import QuotesOptionsView from "./components/quotes/options/view.vue";
import QuotesProductsCreate from "./components/quotes/products/create.vue";
import QuotesProductsCreateContacts from "./components/quotes/products/create-contacts.vue";
import QuotesProductsEdit from "./components/quotes/products/edit.vue";
import QuotesProductsView from "./components/quotes/products/view.vue";
import QuotesProductsCreateMulti from "./components/quotes/products/create-multi.vue";
import QuotesProductsAlternativeEditor from "./components/quotes/products/alternative-editor.vue";
import QuotesProductsSignableEditor from "./components/quotes/products/signable-editor.vue";
import ProductsSearch from "./components/products/search.vue";
import SurveysEditor from "./components/surveys/editor.vue";
import SurveysInput from "./components/surveys/input.vue";
import SurveysPendingPopup from "./components/surveys/pending-popup.vue";
import SurveysData from "./components/surveys/data.vue";
import ProductsBundlesEditor from "./components/products/bundles/editor.vue";
import IntegrationsEditor from "./components/integrations/editor.vue";
import QuotesModalsAddSignature from "./components/quotes/modals/add_signature.vue";
import QuotesModalsInvite from "./components/quotes/modals/invite.vue";
import QuotesDocumentsView from "./components/quotes/documents/view.vue";
import QuoteDocumentsModalsCustomerUpload from "./components/quote_documents/modals/customer_upload.vue";
import QuoteChatMessagesViewLatest from "./components/quote_chat_messages/view-latest.vue";
import QuoteChatMessagesModal from "./components/quote_chat_messages/modal.vue";
import QuoteChatMessagesChat from "./components/quote_chat_messages/chat.vue";
import GoogleTranslateLanguageSelect from "./components/google_translate/language_select.vue";
import LeadsForm from "./components/leads/form.vue";
import LeadsFieldsetCaparolBasic from "./components/leads/fieldset/caparol/basic.vue";
import LeadsIndex from "./components/leads/index.vue";
import TermsFieldset from "./components/terms/fieldset.vue";
import TermsShow from "./components/terms/show.vue";
import ImageCarouselItemsFieldset from "./components/image_carousel_items/fieldset.vue";
import ReadmoreV2Fieldset from "./components/readmore_v2/fieldset.vue";
import ReadmoreV2View from "./components/readmore_v2/view.vue";
import ModelAuthenticationView from "./components/model_authentication/view.vue";
import CallBack from "./components/viewComponents/callBack.vue";
import SplashScreen from "./components/viewComponents/splashScreen.vue";
import ViewHeader from "./components/viewComponents/viewHeader.vue";
import UspBlock from "./components/viewComponents/uspBlock.vue";
import ReadMore from "./components/viewComponents/readMore.vue";
import StatsQuotedAmount from "./components/stats/quotedAmount.vue";
import StatsClosedAmount from "./components/stats/closedAmount.vue";
import StatsQuoteCount from "./components/stats/quoteCount.vue";
import StatsTimeToSignAverage from "./components/stats/timeToSignAverage.vue";
import StatsTimeToSignDistribution from "./components/stats/timeToSignDistribution.vue";
import StatsHitRate from "./components/stats/hitRate.vue";
import StatsHitRateDistribution from "./components/stats/hitRateDistribution.vue";
import StatsDashboard from "./components/stats/dashboard.vue";
import ChartsBar from "./components/charts/bar.vue";
import ChartsHorizontalBar from "./components/charts/horizontalBar.vue";
import DataAnalysisStats from "./components/data_analysis/stats.vue";
import DataAnalysisQuotes from "./components/data_analysis/quotes.vue";
import DataAnalysisQuotesSelector from "./components/data_analysis/quotesSelector.vue";
import CalendlyPopup from "./components/calendly/popup.vue";
import MeetingRequestsPopup from "./components/meeting_requests/popup.vue";
import BilettoPopup from "./components/billetto/popup.vue";
import BilettoInline from "./components/billetto/inline.vue";
import BillectaAccountsRetrieval from "./components/billecta/accounts-retrieval.vue";
import BriteAccountsRetrieval from "./components/brite/accounts-retrieval.vue";
import PoweredBySalesbyte from "./components/poweredBySalesbyte.vue";
import ImageCropperInput from "./components/image_cropper/input.vue";
import ImgBadge from "./components/imgBadge.vue";
import PhoneInput from "./components/phone-input.vue";
import SellerPicker from "./components/seller-picker.vue";
import QuoteFieldset from "./components/quote_fieldset/index.vue";
import QuoteField from "./components/quote_fieldset/field.vue";
import FormFieldset from "./components/form_fieldset/index.vue";
import FormField from "./components/form_fieldset/field.vue";
import SwishRecurringCheckout from "./components/swish/recurring-checkout.vue";

// Register components
app.component("axios-form", AxiosForm);
app.component("pdf-multi-view", PdfMultiView);
app.component("pdf-view", PdfView);
app.component("pdf-all", PdfAll);
app.component("primary-signature-prompt", PrimarySignaturePrompt);
app.component("quote-checkout-iframe", QuoteCheckoutIframe);
app.component("quote-checkout-iframe-modal", QuoteCheckoutIframeModal);
app.component("bank-id-sign", BankIdSign);
app.component("on-screen-sign", OnScreenSign);
app.component("external-sign", ExternalSign);
app.component("simple-sign", SimpleSign);
app.component("bank-id-v2-sign", BankIdV2Sign);
app.component("bank-id-v2-prompt", BankIdV2Prompt);
app.component("quote-product-payment", QuoteProductPayment);
app.component("quotes-index", QuotesIndex);
app.component("quotes-contact-input", QuotesContactInput);
app.component(
    "quotes-duplicate-validated-input",
    QuotesDuplicateValidatedInput
);
app.component("quote-signature-poller", QuoteSignaturePoller);
app.component("quote-edit-tags", QuoteEditTags);
app.component("quote-messages-create", QuoteMessagesCreate);
app.component("quotes-project-approval", QuotesProjectApproval);
app.component("expandable-card", ExpandableCard);
app.component("quotes-options-view", QuotesOptionsView);
app.component("quotes-products-create", QuotesProductsCreate);
app.component("quotes-products-create-contacts", QuotesProductsCreateContacts);
app.component("quotes-products-edit", QuotesProductsEdit);
app.component("quotes-products-view", QuotesProductsView);
app.component("quotes-products-create-multi", QuotesProductsCreateMulti);
app.component(
    "quotes-products-alternative-editor",
    QuotesProductsAlternativeEditor
);
app.component("quotes-products-signable-editor", QuotesProductsSignableEditor);
app.component("products-search", ProductsSearch);
app.component("surveys-editor", SurveysEditor);
app.component("surveys-input", SurveysInput);
app.component("surveys-pending-popup", SurveysPendingPopup);
app.component("surveys-data", SurveysData);
app.component("products-bundles-editor", ProductsBundlesEditor);
app.component("integrations-editor", IntegrationsEditor);
app.component("quotes-modals-add-signature", QuotesModalsAddSignature);
app.component("quotes-modals-invite", QuotesModalsInvite);
app.component("quotes-documents-view", QuotesDocumentsView);
app.component(
    "quote-documents-modals-customer-upload",
    QuoteDocumentsModalsCustomerUpload
);
app.component("quote-chat-messages-view-latest", QuoteChatMessagesViewLatest);
app.component("quote-chat-messages-modal", QuoteChatMessagesModal);
app.component("quote-chat-messages-chat", QuoteChatMessagesChat);
app.component(
    "google-translate-language-select",
    GoogleTranslateLanguageSelect
);
app.component("leads-form", LeadsForm);
app.component("leads-fieldset-caparol-basic", LeadsFieldsetCaparolBasic);
app.component("leads-index", LeadsIndex);
app.component("terms-fieldset", TermsFieldset);
app.component("terms-show", TermsShow);
app.component("image-carousel-items-fieldset", ImageCarouselItemsFieldset);
app.component("readmore-v2-fieldset", ReadmoreV2Fieldset);
app.component("readmore-v2-view", ReadmoreV2View);
app.component("model-authentication-view", ModelAuthenticationView);
app.component("call-back", CallBack);
app.component("splash-screen", SplashScreen);
app.component("view-header", ViewHeader);
app.component("usp-block", UspBlock);
app.component("read-more", ReadMore);
app.component("stats-quoted-amount", StatsQuotedAmount);
app.component("stats-closed-amount", StatsClosedAmount);
app.component("stats-quote-count", StatsQuoteCount);
app.component("stats-time-to-sign-average", StatsTimeToSignAverage);
app.component("stats-time-to-sign-distribution", StatsTimeToSignDistribution);
app.component("stats-hit-rate", StatsHitRate);
app.component("stats-hit-rate-distribution", StatsHitRateDistribution);
app.component("stats-dashboard", StatsDashboard);
app.component("charts-bar", ChartsBar);
app.component("charts-horizontal-bar", ChartsHorizontalBar);
app.component("data-analysis-stats", DataAnalysisStats);
app.component("data-analysis-quotes", DataAnalysisQuotes);
app.component("data-analysis-quotes-selector", DataAnalysisQuotesSelector);
app.component("calendly-popup", CalendlyPopup);
app.component("meeting-requests-popup", MeetingRequestsPopup);
app.component("billetto-popup", BilettoPopup);
app.component("billetto-inline", BilettoInline);
app.component("billecta-accounts-retrieval", BillectaAccountsRetrieval);
app.component("brite-accounts-retrieval", BriteAccountsRetrieval);
app.component("powered-by-salesbyte", PoweredBySalesbyte);
app.component("image-cropper-input", ImageCropperInput);
app.component("img-badge", ImgBadge);
app.component("phone-input", PhoneInput);
app.component("seller-picker", SellerPicker);
app.component("quote-fieldset", QuoteFieldset);
app.component("quote-field", QuoteField);
app.component("form-fieldset", FormFieldset);
app.component("form-field", FormField);
app.component("swish-recurring-checkout", SwishRecurringCheckout);

// Autoload components
const modules = import.meta.glob(
    [
        "./components/autoload/**/*.vue",
        "!./components/autoload/**/_*.vue", // Exclude files starting with underscore
    ],
    { eager: true }
);

Object.entries(modules).forEach(([path, module]) => {
    // Remove './components/autoload/' from the start and '.vue' from the end
    const name = path
        .substring("./components/autoload/".length, path.length - 4)
        .replace(/\//g, "-");
    app.component(name, module.default);
});

// Plugins
import ActionLog from "./vue-plugins/action-log.js";
import Document from "./vue-plugins/document.js";
import Page from "./vue-plugins/page.js";
import Underscore from "./vue-plugins/underscore.js";

app.use(ActionLog);
app.use(Document);
app.use(Page);
app.use(Underscore);

// Vue/Alpine app initialization
import { markPdfRenderMountComplete } from "./pdf-render-tracker";

const appRoot = document.querySelector("#app:not(.disable-vue)");
if (appRoot) {
    app.mount(appRoot);
}
markPdfRenderMountComplete();
// Convert require.context for window functions to import.meta.glob
const windowScripts = import.meta.glob("./windowFunctions/*.js", {
    eager: true,
});
Object.entries(windowScripts).forEach(([key, module]) => {
    // Remove leading './' and trailing '.js'
    const functionName = key
        .replace("./windowFunctions/", "")
        .replace(".js", "");

    window[functionName] = module.default;
});

// Import the jQuery-based scripts as ES modules
import actionLogPriorityFilter from "./src/actionLogPriorityFilter.js";
import selectDisableUnless from "./src/selectDisableUnless.js";
import checkboxDisablesFormField from "./src/checkboxDisablesFormField.js";
import assignsStyleFromOption from "./src/assignsStyleFromOption.js";
import requiredIfInput from "./src/requiredIfInput.js";
import requiredIfSelect from "./src/requiredIfSelect.js";
import navigateOnChecked from "./src/navigateOnChecked.js";
import disableGlobalFileDrops from "./src/disableGlobalFileDrops.js";
import docHeight from "./src/docHeight.js";
import swedishPersonalIdNumberInput from "./src/swedishPersonalIdNumberInput.js";
import swedishBankInput from "./src/swedishBankInput.js";
import disableOnSubmit from "./src/disableOnSubmit.js";
import toggleOnChange from "./src/toggleOnChange.js";

// When the document is ready, run the imported functions
window.jQuery(document).ready(() => {
    actionLogPriorityFilter();
    selectDisableUnless();
    checkboxDisablesFormField();
    assignsStyleFromOption();
    requiredIfInput();
    requiredIfSelect();
    navigateOnChecked();
    disableGlobalFileDrops();
    docHeight();
    swedishPersonalIdNumberInput();
    swedishBankInput();
    disableOnSubmit();
    toggleOnChange();
});
